import { call, delay, put } from 'redux-saga/effects';

import { ISubscriptionWellfunnel } from 'api/components/Subscriptions/types';

import { fetchSubscriptionsSuccess } from '../actions';

import { getSubscription } from './getSubscription';

export function* pollGetSubscriptions(conditionCheck?: (data: ISubscriptionWellfunnel[]) => boolean) {
    let isConditionSatisfied = false;

    let result: ISubscriptionWellfunnel[] = [];

    while (!isConditionSatisfied) {
        result = yield call(getSubscription);

        isConditionSatisfied = !conditionCheck || !result || conditionCheck(result);

        if (!isConditionSatisfied) {
            // Wait for 2 seconds before polling again
            yield delay(2000);
        }
    }

    yield put(fetchSubscriptionsSuccess(result ?? []));

    return result ?? [];
}
